import { WorkflowTask, Step, Assignee } from "../ReviewsInProgress";
import { WmFlyout } from "@watermarkinsights/ripple-react";
import translate from "@/i18n/translate";
import { formatDateFullYear } from "@/features/common/helper";
import { getTaskState } from "./WorkflowTaskStepTooltip";
import { stepClass } from "./WorkflowTaskStep";
import {
  IN_PROGRESS_STATUS,
  ON_HOLD_STATUS,
  SKIPPED_STATUS
} from "@/features/common/constants";

interface WorkFlowTaskFlyoutProps {
  CloseDrilldownView: () => void;
  workflowTask: WorkflowTask;
  open: boolean;
}

export function WorkFlowTaskFlyout({
  CloseDrilldownView,
  workflowTask,
  open
}: WorkFlowTaskFlyoutProps) {
  const closeDrillDownView = () => {
    CloseDrilldownView();
  };
  const flyoutWidth = "860px";

  return (
    <WmFlyout
      id="drill-down-view"
      heading={workflowTask.title}
      open={open}
      onWmFlyoutCloseTriggered={closeDrillDownView}
      onWmFlyoutPrimaryTriggered={closeDrillDownView}
      flyoutWidth={flyoutWidth}
      primaryText="Close"
    >
      <div className="fs-rpt-flyout">
        <section id="fs-rpt-table" className="workflowtasks-steps-table">
          <Table>
            <TableHeader />
            <TableBody workflowTask={workflowTask} />
          </Table>
        </section>
      </div>

    </WmFlyout>
  );
}

interface TableBodyProps {
  workflowTask: WorkflowTask;
}

interface GetDateProps {
  step: Step;
}

function submittedDate(submittedDate: string) {
  return <div className="date">{formatDateFullYear(submittedDate)}</div>;
}

function dueDate(dueDate: string) {
  return <div className="date">{formatDateFullYear(dueDate)}</div>;
}

const GetDate = ({ step }: GetDateProps) => {
  switch (true) {
    case !!step.submittedDate:
      return submittedDate(step.submittedDate);

    case !!step.dueDate:
      return dueDate(step.dueDate);

    default:
      return `-`;
  }
};
interface WorkflowTaskAssigneeNameProps {
  step: Step;
  assignee: Assignee;
  index: number;
}
const WorkflowTaskAssigneeName = ({
  step,
  assignee,
  index
}: WorkflowTaskAssigneeNameProps) => {
  return (
    <div>
      <span> {`${assignee.firstName}`}</span>
      <span> {assignee.middleName ? assignee.middleName : ""}</span>
      <span> {assignee.lastName}</span>
      {index < step.assignees.length - 1 ? "," : ""}
    </div>
  );
};

interface WorkflowTaskRowProps {
  step: Step;
}

const WorkflowTaskRow = ({ step }: WorkflowTaskRowProps) => {
  return (
    <tr
      className={
        step.state === IN_PROGRESS_STATUS ? "in-progress datarow" : "datarow"
      }
    >
      <td className="datacell">
        <div className={`tooltip-state ${stepClass(step?.state)}`}>
          {getTaskState(step?.state)}
        </div>
      </td>
      <td className="datacell">{step.stepIndex + 1}</td>
      <td className="datacell">{step.name}</td>
      <td className="datacell">
        {step.assignees.map((assignee: Assignee, index: number) => {
          return (
            <WorkflowTaskAssigneeName
              step={step}
              assignee={assignee}
              key={`row-${index}-${step.id}`}
              index={index}
            />
          );
        })}
      </td>
      <td className="datacell">
        {step.state === ON_HOLD_STATUS || step.state === SKIPPED_STATUS ? (
          `-`
        ) : (
          <GetDate step={step} />
        )}
      </td>
    </tr>
  );
};

const TableBody = ({ workflowTask }: TableBodyProps) => {
  return (
    <tbody className="databody">
      {workflowTask.steps.map((step: Step, index: number) => {
        return <WorkflowTaskRow step={step} key={`body-${index}`} />;
      })}
    </tbody>
  );
};

const Table = (props: any) => {
  return (
    <table id="flyout-table" className="data-table -shadow">
      {props.children}
    </table>
  );
};

const TableHeader = () => {
  let columns = [
    translate("app.home.WorkflowTaskFlyout.status"),
    translate("app.home.WorkflowTaskFlyout.id"),
    translate("app.home.WorkflowTaskFlyout.StepName"),
    translate("app.home.WorkflowTaskFlyout.AssigneeName"),
    translate("app.home.WorkflowTaskFlyout.dueOrCompletedDate")
  ];
  return (
    <thead className="dataheader">
      <tr className="dataheaderrow">
        {columns.map((column: JSX.Element, index: number) => {
          return (
            <th
              className="dataheadercell"
              data-th={column}
              key={`column-${index}`}
            >
              <span>{column}</span>
            </th>
          );
        })}
      </tr>
    </thead>
  );
};
